<template>
	<div>
		<el-form :model="from" :rules="rules" ref="from" label-width="100px" class="demo-ruleForm">
			<el-form-item label="岗位" prop="sign_post">
				<setPost ref="setPost" type="checkbox" :accordion="true" @commit="monitorCheckboxChange"
					:post_ids_prop="from.sign_post"></setPost>
			</el-form-item>
			<el-form-item label="合同模板" prop="sign_template">
				<el-checkbox-group v-model="from.sign_template" style="width:92%">
					<el-checkbox v-for="item in templateList" :key="item.id" :label="item.id">{{item.template_name}}
					</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="起止时间" prop="start_stop_date">
				<el-date-picker v-model="from.start_stop_date" style="width:92%" type="daterange" range-separator="至"
					value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="状态" prop="state">
				<el-select v-model="from.state" style="width:92%" placeholder="请选择">
					<el-option label="已生效" value="1"></el-option>
					<el-option label="未生效" value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="text-align: center;" label-width="0px">
				<el-button type="goon" @click="Add()" v-show="from.id === null || from.id === ''">保存</el-button>
				<el-button type="goon" @click="Modify()" v-show="from.id != null && from.id != ''">修改</el-button>
				<el-button type="addbtn" @click="resetForm()">重置</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import setPost from './SetPost.vue';
	export default {
		components: {
			setPost: setPost
		},
		props: ["organizeList"],
		data() {
			return {
				//模板数据
				templateList: [],

				//表单数据
				from: {
					id: "",
					project_id: "",
					organize_ids: "",
					start_stop_date: [],
					state: "",
					sign_post: [],
					sign_template: [],
				},

				//表单验证
				rules: {
					sign_post: [{
						type: 'array',
						required: true,
						message: '请至少选择一个岗位！',
						trigger: 'change'
					}],
					sign_template: [{
						type: 'array',
						required: true,
						message: '请至少选择一个合同模板！',
						trigger: 'change'
					}],
					start_stop_date: [{
						type: 'array',
						required: true,
						message: '请选择起止日期！',
						trigger: 'change'
					}],
					state: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}],
				}
			};
		},
		methods: {
			//多选点击事件
			monitorCheckboxChange(e) {
				this.from.sign_post = e.post_ids;
				this.from.project_id = e.organize_id;
				this.from.organize_ids = e.organize_id;
			},
			Add() {
				this.$refs["from"].validate(async (valid) => {
					if (valid) {
						var record = {
							project_id: this.from.project_id,
							organize_ids: this.from.organize_ids,
							start_date: this.from.start_stop_date[0],
							end_date: this.from.start_stop_date[1],
							state: this.from.state,
							sign_post: this.from.sign_post,
							sign_template: this.from.sign_template,
						};
						var result = await this.$globals.AxiosPost("SignContract/insert", record);
						if (result != '-2000') {
							var data = result.data;
							var code = result.code;
							if (code === '200') {
								this.$message.success(data);
								this.$parent.$parent.dialogVisible = false;
								this.$parent.$parent.Find();
							} else {
								this.$message.warning(data);
							}
						} else {
							this.$message.error("服务器未响应！请稍后重试");
						}


					}
				});
			},
			Modify() {
				this.$refs["from"].validate(async (valid) => {
					if (valid) {

						var record = {
							id: this.from.id,
							project_id: this.from.project_id,
							start_date: this.from.start_stop_date[0],
							end_date: this.from.start_stop_date[1],
							state: this.from.state,
							sign_post: this.from.sign_post,
							sign_template: this.from.sign_template,
						};
						var result = await this.$globals.AxiosPost("SignContract/update", record);
						if (result != '-2000') {
							var data = result.data;
							var code = result.code;
							if (code === '200') {
								this.$message.success(data);
								this.$parent.$parent.dialogVisible = false;
								this.$parent.$parent.Find();
							} else {
								this.$message.warning(data);
							}
						} else {
							this.$message.error("服务器未响应！请稍后重试");
						}


					}
				});
			},
			resetForm() {
				this.$refs["from"].resetFields();
			}
		},
		created() {
			//获取合同模板数据
			this.templateList = this.$parent.$parent.templateList;
			//获取父组件数据
			this.from = this.$parent.$parent.from;
		},
	}
</script>

<style scoped="scoped">
	>>>.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #006E4B;
	}

	>>>.el-collapse-item__content {
		padding-bottom: 0px;
	}
</style>



// WEBPACK FOOTER //
// HtqdFq_add.vue?5e318732